export default __webpack_public_path__ + "static/media/news8.b990abdb.mp4";